import { render, staticRenderFns } from "./NotificationsSection.vue?vue&type=template&id=13b6451a&scoped=true&"
import script from "./NotificationsSection.vue?vue&type=script&lang=js&"
export * from "./NotificationsSection.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsSection.vue?vue&type=style&index=0&id=13b6451a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b6451a",
  null
  
)

export default component.exports